import classnames from "classnames";
import * as React from "react";
import "./style.less";

export interface LoadingProps {
  isLight?: boolean;
  isAdminColor?: boolean;
  isFontSize?: boolean;
}

export const Loading = (props: LoadingProps) => (
  <div
    className={classnames("wsc_loading", {
      admin: props.isAdminColor,
      light: props.isLight,
      font_size: props.isFontSize
    })}
  />
);

export type Props = LoadingProps & {
  isAbsolute?: boolean;
  isTransparent?: boolean;
  height?: number | string;
  opacity?: number;
};
export default ({ isTransparent, isAbsolute, ...props }: Props) => (
  <div
    className={classnames("wsc_loading_container", { absolute: isAbsolute, transparent: isTransparent })}
    style={{ height: props.height, opacity: props.opacity }}
  >
    <Loading {...props} />
  </div>
);
